// make fie for setting like currency, language, timezone, etc.
import countryData from "../Pages/Auth/country.json";
import contryDatawithState from "../utils/countries.json"
export const config = {
    currency: "₹",
    language: "en",
    timezone: "UTC",
}

export const getPathName = () => {
  return window.location.pathname; // Returns the current page path
};

export const detectCountryCode = async () => {
  try {
    const response = await fetch("https://ipapi.co/json/");
    const data = await response.json();
    const countryCode = data.country_calling_code; // e.g., "IN" for India

    if (countryCode) {
      const country = countryData.find((c) => c.dialCode  === countryCode); // Use "code" instead of "country_code"

      console.log("Country" ,country);
      if (country) {
        const pathName = getPathName(); // Get current pathname

        return pathName === "/login" ? country.dialCode : country.country;
      }
    }
  } catch (error) {
    console.error("Error detecting location:", error);
  }

  // Default values if detection fails
  return getPathName() === "/login" ? "+91" : "India";
};

export const detectCountryCodeForHome = async () => {
  try {
    const response = await fetch("https://ipapi.co/json/");
    const data = await response.json();
    const countryCode = data.country_code; // e.g., "IN" for India

    if (countryCode) {
      // Access countries array correctly
      const country = contryDatawithState.countries.find((c) => c.code === countryCode);
      if (country) {
        const pathName = window.location.pathname; // Get current pathname
        return pathName === "/login" ? `+${country.dialCode || "91"}` : country.country;
      }
    }
  } catch (error) {
    console.error("Error detecting location:", error);
  }

  // Default values if detection fails
  return window.location.pathname === "/login" ? "+91" : "India";
};

export const detectCountryCodeForBusiness = async (pincode) => {
  try {
    const response = await fetch(`https://nominatim.openstreetmap.org/search?postalcode=${pincode}&format=json&addressdetails=1`);
    
    const data = await response.json();

    if (data.length > 0) {
      const country = data[0].address.country;
      const state = data[0].address.state || data[0].address.region;
      const city = data[0].address.city || data[0].address.town || data[0].address.village;

      return { country, state, city };
    } else {
      throw new Error("No data found for this pincode");
    }
  } catch (error) {
    console.error("Error detecting location from pincode:", error);
  }

  return { country: null, state: null, city: null };
};